import React, { memo, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import '../../../assets/scss/settings.scss';

const ChecklistEditor = ({ keyName, data, sampleData, updateCheckList, setJsonError }) => {
    const [error, setError] = useState(null);
    const [editedJson, setEditedJson] = useState({});

    useEffect(() => {
        if (data) setEditedJson(JSON.stringify(data, null, 2));
        else setEditedJson(JSON.stringify(sampleData, null, 2));
    }, [data])

    const handleEditorChange = (value) => {
        try {
            let valid = validateJSON(value)
            setEditedJson(value);
            if (!valid)
                updateCheckList(keyName, JSON.parse(value));
        } catch (error) {
            setError(true);
        }
    };

    function validateJSON(jsonString) {
        try {
            JSON.parse(jsonString);
            setError(false);
            setJsonError(false);
            return false;
        } catch (error) {
            setJsonError(true);
            setError(error.message);
            return true;
        }
    }

    return (
        <Row className="row">
            <Col className="col-8">
                <code>
                    <textarea
                        className="code-space"
                        value={editedJson}
                        onChange={(e) => handleEditorChange(e.target.value)}
                    />
                </code>
            </Col>
            <Col className="col-8 d-flex justify-content-end col my-3 mx-3">
                {error ? <p className="text-danger" title={error ? error.toString() : ''}>Above JSON has a syntax error</p> : null}
            </Col>
        </Row>
    );
};

export default memo(ChecklistEditor);